export default __webpack_public_path__ + "static/pilot-f7a39cbda5038ce45e2bb907a2085d73.jpg";